import { Component, OnInit, Input } from '@angular/core';
declare const $: any;
declare var Morris: any;
import * as firebase from 'firebase/app';
@Component({
  selector: 'app-section2-1',
  templateUrl: './section2-1.component.html',
  styleUrls: ['./section2-1.component.css']
})
export class Section21Component implements OnInit {
  pieChartOption:any;
  currentDate:any;
  @Input("role") role;
  filter:any;
  year1:any;
  year2:any;
  constructor() { 
    this.currentDate = new Date();
  }

  ngOnInit() {
    this.filter  = 1;
    if(this.role == 'super admin')
    {
      this.getData(1);
    }
    else
    {
      this.getDataForBranch(1);
    }
    this.year1 = this.currentDate.getFullYear() - 1;
    this.year2 = this.currentDate.getFullYear();
  }
  getData(filter)
  {
  var prev_year = this.currentDate.getFullYear() - 1;
  var current_year = this.currentDate.getFullYear();
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
firebase.database().ref("shipments").once("value",(data)=>{
  var shipments = data.val();
  var j = 0;
  var array_shipments;
  array_shipments = [];
  while(j < 12)
  {
    var countOfShipmentsprev = 0;
    var countOfShipmentscurr = 0;
    var cashprev = 0;
    var cashcurr = 0;
    for(let i in shipments)
    {
      if(shipments[i].destination.date !=null && shipments[i].destination.date.year == prev_year)
      {
        if(shipments[i].destination.date.month == j+1)
        {
          countOfShipmentsprev++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashprev = cashprev + shipments[i].cashCollected;
          }
        }
      }
      else if(shipments[i].source.date !=null && shipments[i].source.date.year == prev_year)
      {
        if(shipments[i].source.date.month == j+1)
        {
          countOfShipmentsprev++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashprev = cashprev + shipments[i].cashCollected;
          }
        }
      }
      else if(shipments[i].destination.date !=null && shipments[i].destination.date.year == current_year)
      {
        if(shipments[i].destination.date.month == j+1)
        {
          countOfShipmentscurr++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashcurr = cashcurr + shipments[i].cashCollected;
          }
        }
      }
      else if(shipments[i].source.date !=null && shipments[i].source.date.year == current_year)
      {
        if(shipments[i].source.date.month == j+1)
        {
          countOfShipmentscurr++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashcurr = cashcurr + shipments[i].cashCollected;
          }
        }
      }
    }
    if(filter == 1)
    {
      array_shipments.push({
        y: months[j],
        [prev_year] : countOfShipmentsprev,
        [current_year]: countOfShipmentscurr
      });
    }
    else
    {
      array_shipments.push({
        y: months[j],
        [prev_year] : cashprev,
        [current_year]: cashcurr
      });
    }
    j++;
  }
  setTimeout(() => {
    //console.log("array_shipments",array_shipments);
    if(this.filter == 1)
    {
      Morris.Bar({
        element: 'morris-bar-chart1',
        data: array_shipments,
        xkey: 'y',
        ykeys: [prev_year, current_year],
        labels: [prev_year, current_year],
        barColors: ['#5FBEAA', '#5D9CEC'],
        hideHover: 'auto',
        gridLineColor: '#eef0f2',
        resize: true
    });
    }
    else
    {
      Morris.Bar({
        element: 'morris-bar-chart2',
        data: array_shipments,
        xkey: 'y',
        ykeys: [prev_year, current_year],
        labels: [prev_year, current_year],
        barColors: ['#5FBEAA', '#5D9CEC'],
        hideHover: 'auto',
        gridLineColor: '#eef0f2',
        resize: true
    });
    }
    
  }, 500);
});
}
getDataForBranch(filter)
{
var prev_year = this.currentDate.getFullYear() - 1;
var current_year = this.currentDate.getFullYear();
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
firebase.database().ref("shipments").orderByChild("branch").equalTo(localStorage.getItem("branch")).once("value",(data)=>{
var shipments = data.val();
var j = 0;
var array_shipments;
array_shipments = [];
while(j < 12)
{
  var countOfShipmentsprev = 0;
  var countOfShipmentscurr = 0;
  var cashprev = 0;
  var cashcurr = 0;
  for(let i in shipments)
  {
    if(shipments[i].destination.date !=null && shipments[i].destination.date.year == prev_year)
    {
      if(shipments[i].destination.date.month == j+1)
      {
        countOfShipmentsprev++;
        if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
        {
          cashprev = cashprev + shipments[i].cashCollected;
        }
      }
    }
    else if(shipments[i].source.date !=null && shipments[i].source.date.year == prev_year)
      {
        if(shipments[i].source.date.month == j+1)
        {
          countOfShipmentsprev++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashprev = cashprev + shipments[i].cashCollected;
          }
        }
      }
    else if(shipments[i].destination.date !=null && shipments[i].destination.date.year == current_year)
    {
      if(shipments[i].destination.date.month == j+1)
      {
        countOfShipmentscurr++;
        if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
        {
          cashcurr = cashcurr + shipments[i].cashCollected;
        }
      }
    }
    else if(shipments[i].source.date !=null && shipments[i].source.date.year == current_year)
      {
        if(shipments[i].source.date.month == j+1)
        {
          countOfShipmentscurr++;
          if(shipments[i].cashCollected != null && shipments[i].cashCollected > 0)
          {
            cashcurr = cashcurr + shipments[i].cashCollected;
          }
        }
      }
      //console.log("cash", cashcurr);
  }
  if(filter == 1)
  {
    array_shipments.push({
      y: months[j],
      [prev_year] : countOfShipmentsprev,
      [current_year]: countOfShipmentscurr
    });
  }
  else
  {
    array_shipments.push({
      y: months[j],
      [prev_year] : cashprev,
      [current_year]: cashcurr
    });
  }
  j++;
}
setTimeout(() => {
  //console.log("array_shipments",array_shipments);
  if(this.filter == 1)
  {
    Morris.Bar({
      element: 'morris-bar-chart1',
      data: array_shipments,
      xkey: 'y',
      ykeys: [prev_year, current_year],
      labels: [prev_year, current_year],
      barColors: ['#5FBEAA', '#5D9CEC'],
      hideHover: 'auto',
      gridLineColor: '#eef0f2',
      resize: true
  });
  }
  else
  {
    Morris.Bar({
      element: 'morris-bar-chart2',
      data: array_shipments,
      xkey: 'y',
      ykeys: [prev_year, current_year],
      labels: [prev_year, current_year],
      barColors: ['#5FBEAA', '#5D9CEC'],
      hideHover: 'auto',
      gridLineColor: '#eef0f2',
      resize: true
  });
  }
  
}, 500);
});
}
selectedFilter(event)
{
  this.filter = event.target.value;
  if(this.role == 'super admin')
    {
      this.getData(event.target.value);
    }
    else
    {
      this.getDataForBranch(event.target.value);
    }
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section2-1/section2-1.component.ts